export default "__VITE_ASSET__1zWp5WnU__"